import React from 'react';

const sampleUser = {
  name: "Jane Doe",
  username: "janedoe123",
  email: "janedoe@example.com",
  affiliation: "University of Example",
  googleScholarProfile: "https://scholar.google.com",
  postersOrTalks: "The Impact of Examples in Programming, Exploring Example University",
  interests: "Computer Science, Education, Example Studies",
  profilePicture: '/images/profile.jpg', 
};

const UserProfile = () => {

  const user = sampleUser; 

  return (
    <div className="user-profile">
      <div className="profile-header">
      <div className="profile-picture">
        {user.profilePicture ? (
          <img src={user.profilePicture} alt="Profile" />
        ) : (
          <div className="placeholder">No Image</div>
        )}
      </div>
      <button className="edit-button">Edit</button>
      </div>
      <div className="profile-details">
        <h2>{user.name}</h2>
        <p><strong>Username:</strong> {user.username}</p>
        <p><strong>Email:</strong> {user.email}</p>
        <p><strong>Affiliation:</strong> {user.affiliation}</p>
        <p><strong>Google Scholar Profile:</strong> <a href={user.googleScholarProfile} target="_blank" rel="noopener noreferrer">View Profile</a></p>
        <p><strong>Posters/Talks Authored:</strong> {user.postersOrTalks}</p>
        <p><strong>Interests:</strong> {user.interests}</p>
      </div>
    </div>
  );
};

export default UserProfile;
